import { render, staticRenderFns } from "./alert-update-asset.vue?vue&type=template&id=ad96af56&"
import script from "./alert-update-asset.vue?vue&type=script&lang=js&"
export * from "./alert-update-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad96af56')) {
      api.createRecord('ad96af56', component.options)
    } else {
      api.reload('ad96af56', component.options)
    }
    module.hot.accept("./alert-update-asset.vue?vue&type=template&id=ad96af56&", function () {
      api.rerender('ad96af56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/alert-update-asset/alert-update-asset.vue"
export default component.exports